const ease = [0.4, 0.15, 0.4, 1]
const useTransition = () => ({
  QUICK_TRANSITION: { duration: 0.15, ease },
  STANDARD_TRANSITION: { duration: 0.3, ease },
  STANDARD_TRANSITION_DELAYED: { duration: 0.3, delay: 0.3, ease },
  SLOW_TRANSITION: { duration: 0.45, ease },
})

export default useTransition
